export default {
  forms: {
    meterNumber: 'Laatste 4 cijfers meternummer',
    houseNumber: 'Huisnummer',
    houseNumberAddition: 'Toevoeging',
    zipcode: 'Postcode',
    pchn: 'PCHN',
  },
  buttons: {
    register: 'Registreren',
    back: 'Terug',
    close: 'Sluiten',
  },
  validation: {
    general: {
      required: 'Verplicht veld',
    },
    email: {
      required: 'E-mail is vereist',
      valid: 'Voer een geldig e-mailadres in',
    },
    password: {
      required: 'Wachtwoord is vereist',
      valid:
        'Uw wachtwoord moet minimaal 8 karakters lang zijn, en minimaal 1 hoofdletter, 1 kleine letter, en 1 cijfer bevatten.',
      equal: 'Wachtwoorden zijn niet gelijk',
    },
    zipcode: {
      required: 'Postcode is vereist',
      valid: 'Voer een geldige postcode in',
    },
    houseNumber: {
      required: 'Huisnummer is vereist',
      valid: 'Voer een geldig huisnummer in',
    },
    meterNumber: {
      required: 'Meternummer is vereist',
      valid: 'Voer alleen de laatste 4 cijfers van het meternummer in',
    },
  },
  labels: {},
  menu: {
    service: 'Service',
  },
  service: {
    // Assignment Type labels (backend sends the raw value). Strings mirror the i18nexus cache
    // (frontend/libs/i18n/src/locales/nl/assignments.json → types). The conveyor's inside/outside
    // are omitted: they are planning slots, which no mech app executes.
    types: {
      fire_damage: 'Brandschade',
      storm_damage: 'Stormschade',
      leakage: 'Lekkage',
      no_connection: 'Geen connectie',
      no_yield: 'Geen opwekking',
      abnormal_yield: 'Afwijkende opwekking',
      other_service: 'Overige serviceopdracht',
      retrofit: 'Retrofit',
    },
    questionnaire: {
      attentionTitle: '{count} aandachtspunt(en) voor kantoor',
      openTitle: '{count} punt(en) nog open',
      notReadyTitle: 'Nog niet compleet',
      workActivities: 'Werkomschrijving',
      situation: 'Situatie',
      finishedNotice:
        'Deze serviceopdracht is al afgerond. Je kunt wijzigingen aanbrengen en opnieuw afronden; het opleverdocument wordt dan opnieuw gegenereerd.',
      lockedNotice:
        'Deze serviceopdracht is in beoordeling of beoordeeld. Je kunt de vragenlijst inzien, maar niet meer wijzigen of opnieuw afronden.',
      finish: 'Afronden',
      refinish: 'Opnieuw afronden',
      finishTitle: 'Serviceopdracht afronden?',
      refinishTitle: 'Serviceopdracht opnieuw afronden?',
      finishWarning:
        'Bij afronden wordt het opleverdocument (PDF) gegenereerd.',
      refinishWarning:
        'Bij opnieuw afronden wordt het opleverdocument (PDF) opnieuw gegenereerd en vervangt het de vorige versie.',
      finishConfirm: 'Afronden',
      finishCancel: 'Blijf bewerken',
      finishSuccess: 'Serviceopdracht afgerond.',
      finishError: 'Er ging iets mis bij het afronden. Probeer het opnieuw.',
      missingFields: 'Vul eerst de verplichte velden in: {fields}',
    },
    detail: {
      plannedDate: 'Geplande datum',
      priority: 'Prioriteit',
      installer: 'Installateur',
      meter: 'Meter',
      panels: 'Panelen',
      inverter: 'Omvormer',
      tenant: 'Bewoner',
      phone: 'Telefoon',
      attachments: 'Bijlagen',
      priorities: {
        urgent: 'Urgent',
        high: 'Hoog',
        average: 'Gemiddeld',
        low: 'Laag',
      },
    },
  },
  views: {},
  signIn: {
    app: 'Monteursapp',
    title: 'Inloggen',
    intro:
      'Log in met het e-mailadres waarmee uw werkgever u heeft aangemeld. Een apart Wocozon-wachtwoord is niet nodig.',
    button: 'Inloggen',
    caption:
      'U logt in via het vertrouwde inlogscherm van uw werkgever of Microsoft en komt daarna vanzelf terug in de app.',
    firstTime: {
      title: 'De eerste keer',
      text:
        'Microsoft vraagt eenmalig of Wocozon uw naam en e-mailadres mag zien. Kies {0}. Daarna logt u meestal in met één tik.',
      accept: 'Accepteren',
    },
    help: {
      title: 'Lukt inloggen niet?',
      text:
        'Uw toegang wordt geregeld door uw eigen werkgever. Neem eerst contact op met de beheerder of planner van uw installatiebedrijf. Die kan u toevoegen en controleren met welk e-mailadres u bent aangemeld.',
    },
    more: {
      title: 'Meer informatie over inloggen',
      situations: {
        title: 'Zo logt u in',
        intro:
          'Wocozon maakt geen eigen wachtwoord voor u aan. Het inloggen gebeurt bij de partij die uw e-mailadres beheert. Welke partij dat is, bepaalt Microsoft automatisch aan de hand van uw adres.',
        microsoft365: {
          situation: 'Uw werkgever werkt met Microsoft 365 (Outlook, Teams)',
          login:
            'Met uw eigen werkaccount, precies zoals bij uw werk. Uw wachtwoord en eventuele extra verificatie blijven bij uw werkgever.',
        },
        otherProvider: {
          situation:
            'Uw werkgever werkt niet met Microsoft 365 (bijvoorbeeld Google Workspace of een eigen mailprovider)',
          login: 'U ontvangt bij het inloggen een eenmalige code op uw e-mailadres. Geen wachtwoord, geen nieuw account.',
        },
        personalMicrosoft: {
          situation: 'U gebruikt een persoonlijk Microsoft-adres (Hotmail, Outlook.com, Live)',
          login: 'Met dat persoonlijke account.',
        },
        always: 'In alle gevallen geldt: het adres waarmee u bent toegevoegd, is het adres waarmee u inlogt.',
      },
      faq: {
        title: 'Veelgestelde vragen',
        createAccount: {
          question: 'Moet ik een Microsoft-account aanmaken?',
          answer:
            'Nee. Werkt uw werkgever niet met Microsoft 365, dan logt u in met een eenmalige code per e-mail. Vraagt Microsoft toch om een wachtwoord, dan is er in het verleden al een persoonlijk Microsoft-account op uw adres aangemaakt. U kunt dat wachtwoord via Microsoft herstellen, of uw installatiebedrijf vragen uw toegang op een ander adres te zetten.',
        },
        noEmail: {
          question: 'Ik heb geen e-mail ontvangen.',
          answer:
            'Die wordt ook niet verstuurd. Zodra u bent toegevoegd, kunt u direct inloggen. Uw installatiebedrijf laat weten dat de toegang klaarstaat.',
        },
        unknownAccount: {
          question: 'Ik krijg de melding dat mijn account niet bekend is.',
          answer:
            'U logt dan in met een ander adres dan waarmee u bent toegevoegd. Kies "Inloggen met een ander account" en gebruik het adres waarmee u bent toegevoegd.',
        },
        blocked: {
          question: 'Mijn werkgever blokkeert het inloggen.',
          answer:
            'Sommige organisaties staan samenwerking met externe partijen alleen toe na goedkeuring van hun eigen IT-afdeling. Vraag de IT-afdeling van uw werkgever om Wocozon toe te staan.',
        },
      },
    },
  },
  messages: {
    azureLoginUnavailable: 'Inloggen is op dit moment niet beschikbaar. Neem contact op met uw installatiebedrijf.',
  },
};
